export interface MicrofrontendApp {
	name: string;
	url: string;
	activeWhen: string;
}

export interface MicrofrontendEnvironment {
	apps: MicrofrontendApp[];
}

const environments: MicrofrontendEnvironment = {
	apps: [
		{
			name: "coca-cola/faq-microfrontend",
			url: "https://pg3generalinformation.pg3-poc.coke.com/main.js",
			activeWhen: "/faq",
		},
		{
			name: "@tccc/ideas-bank",
			url: "https://pg3ideasbank.pg3-poc.coke.com/main.js",
			activeWhen: "/ideas-bank",
		},
		{
			name: "@tccc/our_work",
			url: "https://pg3ourwork.pg3-poc.coke.com/main.js",
			activeWhen: "/our-work",
		},
		{
			name: "@tccc/prioritization-process",
			url: "https://pg3prioprocess.pg3-poc.coke.com/main.js",
			activeWhen: "/prioritization-process",
		},
		{
			name: "@tccc/innovation-process",
			url: "https://pg3innovation.pg3-poc.coke.com/main.js",
			activeWhen: "/innovation-process",
		},
		{
			name: "@tccc/onboarding",
			url: "https://pg3onboarding.pg3-poc.coke.com/main.js",
			activeWhen: "/onboarding",
		},
		{
			name: "@tccc/experience-loop",
			url: "https://pg3exploop.pg3-poc.coke.com/main.js",
			activeWhen: "/experience-loop-process",
		},
		{
			name: "@tccc/persistent-platform",
			url: "https://pg3masteroftaste.pg3-poc.coke.com/main.js",
			activeWhen: "/persistent-platform",
		},
		{
			name: "@tccc/tools-and-support",
			url: "https://pg3toolsandsupport.pg3-poc.coke.com/main.js",
			activeWhen: "/tools-and-support",
		},
		{
			name: "@tccc/communities-of-practitioners",
			url: "https://pg3cos.pg3-poc.coke.com/main.js",
			activeWhen: "/communities-of-practitioners",
		},
		{
			name: "@tccc/marketing-capabilities",
			url: "https://pg3mtep.pg3-poc.coke.com/main.js",
			activeWhen: "/marketing-capabilities",
		},
		{
			name: "@tccc/dashboard",
			url: "https://pg3exprofile.pg3-poc.coke.com/main.js",
			activeWhen: "/page-dashboard",
		},
		{
			name: "@tccc/experience-profile",
			url: "https://pg3exprofile.pg3-poc.coke.com/main.js",
			activeWhen: "/experience-profile",
		},
		{
			name: "@tccc/nma-home",
			url: "https://pg3nmalanding.pg3-poc.coke.com/main.js",
			activeWhen: "/nma-home",
		},
		{
			name: "@tccc/nma-gallery",
			url: "https://pg3nmagalleryindex.pg3-poc.coke.com/main.js",
			activeWhen: "/nma-gallery",
		},
		{
			name: "@tccc/bva",
			url: "https://bva.pg3-poc.coke.com/main.js",
			activeWhen: "/bva",
		},
		{
			name: "@tccc/agency-roster",
			url: "https://pg3agencyroster.pg3-poc.coke.com/main.js",
			activeWhen: "/agency-roster"
		}
	],
};

export default environments;